export function anchorLinks() {
    const links = $(".anchor-link");

    links.click(function() {
        let id = $(this).attr("href");

        if($(id).length > 0){
            let top = $(id).offset().top;

            $("body, html").animate({scrollTop: top - $(".header").height() - 10}, 600);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchor-links.js